import {IoClose, IoCloseCircleOutline} from "react-icons/io5";
import {
  AiOutlineClose,
  AiOutlineEye,
  AiOutlineEyeInvisible,
  AiOutlineFieldNumber,
  AiFillTool,
  AiOutlineLock,
  AiOutlineMenu,
  AiOutlineSearch,
  AiOutlineUnlock
} from "react-icons/ai";
import {TfiClip, TfiSave as TfiSaveRaw} from "react-icons/tfi";
import {IconBaseProps} from "react-icons";
import {JSX} from "react";
import {BsActivity, BsBootstrapReboot, BsExclamationTriangle} from "react-icons/bs";
import CopyIcon from "@rsuite/icons/Copy";
import GearIcon from "@rsuite/icons/Gear";
import {
  FaArrowDown,
  FaBan,
  FaCheckCircle,
  FaClock,
  FaPhone,
  FaPlus,
  FaSignInAlt,
  FaSignOutAlt,
  FaUsers
} from "react-icons/fa";
import {VscEdit} from "react-icons/vsc";
import {TiFlowMerge, TiFlowParallel} from "react-icons/ti";
import {MdArrowRightAlt} from "react-icons/md";
import {FiLogOut, FiSend} from "react-icons/fi";
import {RiRobot2Line, RiShieldCheckLine, RiToolsLine} from "react-icons/ri";

type IconType = (props: IconBaseProps) => JSX.Element;

export const IoCloseIcon = IoClose as unknown as IconType;
export const TfiSaveIcon = TfiSaveRaw as unknown as IconType;
export const AiOutlineEyeIcon = AiOutlineEye as unknown as IconType;
export const AiOutlineEyeInvisibleIcon = AiOutlineEyeInvisible as unknown as IconType;
export const BsBootstrapRebootIcon = BsBootstrapReboot as unknown as IconType;
export const CopyBtnIcon = CopyIcon as unknown as IconType;
export const GearSettingsIcon = GearIcon as unknown as IconType;
export const FaClockIcon = FaClock as unknown as IconType;
export const FaArrowDownIcon = FaArrowDown as unknown as IconType;
export const VscEditIcon = VscEdit as unknown as IconType;
export const FaPhoneIcon = FaPhone as unknown as IconType;
export const FaUsersIcon = FaUsers as unknown as IconType;
export const AiFillToolIcon = AiFillTool as unknown as IconType;
export const AiOutlineUnlockIcon = AiOutlineUnlock as unknown as IconType;
export const AiOutlineLockIcon = AiOutlineLock as unknown as IconType;
export const AiOutlineCloseIcon = AiOutlineClose as unknown as IconType;
export const AiOutlineFieldNumberIcon = AiOutlineFieldNumber as unknown as IconType;
export const AiOutlineSearchIcon = AiOutlineSearch as unknown as IconType;
export const IoCloseCircleOutlineIcon = IoCloseCircleOutline as unknown as IconType;
export const TiFlowMergeIcon = TiFlowMerge as unknown as IconType;
export const TiFlowParallelIcon = TiFlowParallel as unknown as IconType;
export const AiOutlineMenuIcon = AiOutlineMenu as unknown as IconType;
export const MdArrowRightAltIcon = MdArrowRightAlt as unknown as IconType;
export const FiLogOutIcon = FiLogOut as unknown as IconType;
export const FaSignInAltIcon = FaSignInAlt as unknown as IconType;
export const BsActivityIcon = BsActivity as unknown as IconType;
export const BsExclamationTriangleIcon = BsExclamationTriangle as unknown as IconType;
export const RiShieldCheckIcon = RiShieldCheckLine as unknown as IconType;
export const RiToolsIcon = RiToolsLine as unknown as IconType;
export const FaPlusIcon =  FaPlus as unknown as IconType;
export const FaCheckCircleIcon = FaCheckCircle as unknown as IconType;
export const FaBanIcon = FaBan as unknown as IconType;
export const TfiClipIcon = TfiClip as unknown as IconType;
export const AiAssistantIcon = RiRobot2Line as unknown as IconType;
export const FiSendIcon = FiSend as unknown as IconType;
